function initMainVisualSwiper() {
  const mvSwiper = new Swiper('.index-mv.swiper', {
    loop: true,
    effect: 'fade', 
    fadeEffect: {
      crossFade: true 
    },
    speed: 2000,    
    
    autoplay: {
      delay: 3000, 
      disableOnInteraction: false,
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    watchOverflow: true,
  });
}
document.addEventListener('DOMContentLoaded', () => {
  initMainVisualSwiper();
});
if (window.innerWidth <= 767) {
  new Swiper('.js-swiper-insta', {
    slidesPerView: 1.5,
    spaceBetween: 8,
    centeredSlides: false,
    pagination: {
      el: '.js-swiper-insta-pagination',
      clickable: true,
    },
  });
}
if (window.innerWidth <= 767) {
  new Swiper('.js-swiper-insta', {
    slidesPerView: 1.5,
    spaceBetween: 8,
    centeredSlides: false,
    pagination: {
      el: '.js-swiper-insta-pagination',
      clickable: true,
    },
  });
}
if (window.innerWidth >= 768) {
  const instaSlides = document.querySelectorAll('.index-insta-photos .swiper-slide');
  if (instaSlides.length > 0) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-insta-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.2 });

    instaSlides.forEach(slide => observer.observe(slide));
  }
}